module.exports = __webpack_public_path__ + "static/NeueMontreal-MediumItalic-2eaa050a37fc3c5b74452ba1ac8d9af1.woff";